/** @jsxImportSource @emotion/react */

interface AccordionBodyProps {
  children: React.ReactNode | React.ReactNode[];
  sx?: React.CSSProperties;
}

/**
 * Simple wrapper with default styling
 *
 * @param sx style object to optionally override component styles
 * @returns
 */
const AccordionBody = ({ children, sx }: AccordionBodyProps) => {
  return (
    <div
      css={{
        width: '100%',
        padding: '6px 18px',
        ...(sx ? sx : {}),
      }}
    >
      {children}
    </div>
  );
};

export default AccordionBody;
